import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Toolbar from '@mui/material/Toolbar';
import { msgTypes } from 'constants/msgTypes';
import * as React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LocalStorageService } from 'services/auth/LocalStorageService';
import showAlert, { logoutAlert } from 'services/shared/alert';
import ApiUrl from 'services/shared/ApiUrl';
import { useAuth } from 'util/auth';


// const pages = ['Products', 'Pricing', 'Blog'];
const settings = ['Profile', 'Dashboard', 'Logout'];


const Header = (props) => {
  const auth = useAuth();
  const navigate = useNavigate();


  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const [reprentativeImage, setReprentativeImage] = React.useState("")
  const [reprentativeName, setReprentativeName] = React.useState("")
  const [comapnyName, setComapnyName] = React.useState("")
  const [userRole, setUserRole] = React.useState("");
  const [isadmin, setIsadmin] = React.useState(false);

  React.useEffect(() => {
    loginUserDetails();
    getUserRole();
  }, [])

  const loginUserDetails = async () => {
    const userDetails = await LocalStorageService.getUserDetails();


    if (userDetails != undefined && userDetails != "") {
      setIsadmin(false)
      const companyDetails = JSON.parse(userDetails);
      setComapnyName(companyDetails.companyName)
      const representativeDetails = companyDetails.contactPerson.filter((data) => {
        return data.contactIsrepresentative === true;

      })
      if (representativeDetails?.length > 0) {
        if (representativeDetails[0].contactImageUrl === "") {
          const name = representativeDetails[0].name;
          const nameChar = name.charAt(0, 1)
          setReprentativeName(nameChar)
        } else {
          const imageUrl = ApiUrl.fileBaseUrl + representativeDetails[0].contactPersonImage;
          setReprentativeImage(imageUrl)
        }
      }
    } else {
      setIsadmin(true)
    }
  }


  const getUserRole = async () => {
    const role = await LocalStorageService.getUserRole();
    setUserRole(role);

  }

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const logout = async () => {
    const logoutFlag = await logoutAlert(msgTypes.CONFORMATION_MESSAGE.LOGOUT, msgTypes.CONFORMATION_ICON.ERROR, "logout");
    if (logoutFlag) {
      localStorage.clear();
      auth.logout();
      navigate('/login');
      showAlert(msgTypes.SUCCESS.msg, msgTypes.LOGGED_OUT, msgTypes.success, msgTypes.OK_KEY);
    }
  };


  return (
    <>
      
      <AppBar className='custom-appbar' position="static">
        <Container maxWidth="xl">
          <Toolbar className='main-area d-flex align-items-center flex-wrap' disableGutters> 
                <div className='card-background'>
                  <div className='header-cards d-flex align-items-center justify-content-between gap-3'>
                    <div className='d-flex'>
                      <div className='diamond-card'>
                        <ContactSupportIcon className='diamond-icon' />
                      </div>
                      <div className='docs-info'>
                        <p className='font-weight-bold'><span className='need'>Need Help?</span></p>
                      </div>
                    </div>

                    <div className='docs'>
                      <a className="btn docs-button">DOCUMENTATION</a>
                    </div>
                  </div>
                </div>

                <div className='d-flex header-responsive'>
                <div className='company-work'>
                  {/* <span className='header-heading'>{comapnyName}</span> */}
                  <p className='text-comapny-name'><span>{comapnyName}</span></p>
                </div>

                <Box className="d-flex" sx={{ flexGrow: 0 }}>
                  {isadmin ? (
                    <IconButton onClick={handleOpenUserMenu}>
                      <div className='admin-img'>
                        <img src="/images/admin.png" alt="" />
                      </div>
                    </IconButton>
                  ) : (
                    <IconButton onClick={handleOpenUserMenu}>
                      {reprentativeImage === "" ? (
                        <Avatar>
                          {reprentativeName}
                        </Avatar>
                      ) : (
                        <Avatar className='avtar-img' alt="Remy Sharp" src={reprentativeImage} />
                      )}

                    </IconButton>
                  )}
                  <Menu
                  className="bar--"
                    sx={{ mt: '45px' }}
                    id="menu-appbar"
                    anchorEl={anchorElUser}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                      
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                      
                    }}
                    open={Boolean(anchorElUser)}
                    onClose={handleCloseUserMenu}
                  >
                 <div className='menuuuu---'>
                 <MenuItem className='menu-items' onClick={handleCloseUserMenu}>
                      <Link to='company-profile'><i className="profile-icon fa fa-user ant-menu-item-icon" aria-hidden="true"></i>Profile</Link>
                    </MenuItem>
                    {/* )} */}
                    <MenuItem className='menu-items' onClick={handleCloseUserMenu}><Link to='dashboard'><i className="fa fa-dashboard fa-lg pl-1 mr-3 "></i>Dashboard</Link></MenuItem>
                    <MenuItem className='logout-color-text' onClick={() => {
                      logout();
                    }}>

                      <i className="log-arrow fa fa-sign-out ant-menu-item-icon" aria-hidden="true"></i>Logout</MenuItem>
                 </div>
                  </Menu>
                </Box>
              </div>
          </Toolbar>
        </Container >
      </AppBar >
    </>



  );
}

export default Header;